export const LINK_TYPE_QUICK = 'quick' as const;
export const QUICK_LINK = 'QUICK_LINK' as const;
